export default __webpack_public_path__ + "static/media/me.bbdc2338.jpg";